import { render, staticRenderFns } from "./termStatis.vue?vue&type=template&id=0170a1bd&scoped=true&"
import script from "./termStatis.vue?vue&type=script&lang=js&"
export * from "./termStatis.vue?vue&type=script&lang=js&"
import style0 from "./termStatis.vue?vue&type=style&index=0&id=0170a1bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0170a1bd",
  null
  
)

export default component.exports